<template>
    <div class="componentWrapper">
        <div class="homeDarkSection" v-if="$route.name == 'home'">
            <img 
                class="illustration"
                :src="require('@/assets/illustrations/51499810204_887d2cc964_k.jpg')" 
                alt=""
            >
            <img 
                class="whiteLogo"
                :src="require('@/assets/logo/whiteLogo.svg')" 
                alt=""
            >
            <h2>{{ $t("footer.darkSectionText") }}</h2>
            <!-- <div class="buttons">
                <RouterLink :to="Tr.i18nRoute({ name: 'products', params: { productUrl: $t(`router.defaultProduct`) } })">{{  $t("footer.darkSectionButtonOne") }}</RouterLink>
                <RouterLink :to="Tr.i18nRoute({ name: 'about' })" style="color: white">{{ $t("footer.darkSectionButtonTwo") }}</RouterLink>
            </div> -->
        </div>
        <div class="footer" :class="{ 'footerSmall': $route.name == 'products' || $route.name == 'about'  || $route.name == 'references' || $route.name == 'privacyPolicy' }">
            
            <div class="bottom" v-if="$route.name != 'about'">
                
                <div class="contact">
                    <div class="leftSide">
                        <div class="colorBox">
                            <h2>Pärnu Betoonelement OÜ</h2>
                            <p style="cursor: pointer; color: steelblue; margin-bottom: 10px; width: fit-content;" @click="openLink()">(Reg. <span style="text-decoration: underline">16329376</span>) (Kmkr. EE102675087)</p>
                            <a href="mailto:info@parnubetoonelement.ee" style="text-decoration: none; font-size: 18px">info@parnubetoonelement.ee</a>
                            <p style="margin-top: 10px;">IBAN: EE21384239902112</p>
                            <p style="margin-bottom: 10px; margin-top: 15px;"><img style="margin-top: 0px; margin-bottom: -10px; margin-left: -5px; margin-right: 3px;" class="inputIcon" :src="require('@/assets/icons/location-svgrepo-com.svg')"/><b style="font-size: 18px;">{{ $t("companyData.title") }}</b> <br><br> <span @click="openMaps('Pilli 6, Pärnu 80013, Pärnu maakond')" style="text-decoration: underline; cursor: pointer; text-align: start; cursor: pointer;">Pilli 6, Pärnu 80013, Pärnu maakond</span></p>
                            <p>
                                <span style="text-decoration: underline; cursor: pointer; text-align: start;" @click="openMaps('Tehnika tn 1, Sauga, 85008 Pärnu maakond')">Tehnika tn 1, Sauga 85008, Pärnu maakond</span>
                            </p>
                        </div>

                        <div class="top">
                            <div class="data">
                                <div class="links">
                                    <RouterLink :to="Tr.i18nRoute({ name: 'privacyPolicy' })">{{ $t("footer.link2") }}</RouterLink>
                                    <RouterLink :to="Tr.i18nRoute({ name: 'about' })">{{ $t("footer.link3") }}</RouterLink>
                                </div>
                                <p>{{  $t("footer.disclaimer") }} {{ new Date().getFullYear() }}</p>
                            </div>
                            <div class="languages" style="width: 104px;">
                                <languageSwitcher class="langSwitcher" @localeChanged="$emit('localeChanged')" />
                            </div>
                        </div>
                    </div>
            <div class="rightSide">
                <h2 class="contactTitle">{{ $t(`buttons.contactUs`) }}</h2>
                <div class="flexContainer">
                    <div class="singleLine">
                        <h2>Janno tarvis</h2>
                        <p class="underTitle" style="font-size: 18px; margin: 0;">{{ $t("companyData.ceo") }}</p>
                        <div class="iconLine">
                            <img class="dataIcon" :src="require('@/assets/icons/dark/phone.svg')"/>
                            <p style="font-size: 18px;">+372 58241908</p>
                        </div>
                        <div class="iconLine">
                            <img class="dataIcon" :src="require('@/assets/icons/dark/email.svg')"/>
                            <a style="text-decoration: underline; font-size: 18px;" href="mailto:janno@parnubetoonelement.ee">janno@parnubetoonelement.ee</a>
                        </div>
                    </div>
                    <div class="singleLine">
                        <h2>Toomas Lauter</h2>
                        <p class="underTitle" style="font-size: 18px; margin: 0;">{{ $t("companyData.production") }}</p>
                        <div class="iconLine">
                            <img class="dataIcon" :src="require('@/assets/icons/dark/phone.svg')"/>
                            <p style="font-size: 18px;">+372 53493813</p>
                        </div>
                        <div class="iconLine">
                            <img class="dataIcon" :src="require('@/assets/icons/dark/email.svg')"/>
                            <a style="text-decoration: underline; font-size: 18px;" href="mailto:toomas@parnubetoonelement.ee">toomas@parnubetoonelement.ee</a>
                        </div>
                    </div>
                    <div class="singleLine" style="margin-top: 25px;">
                        <h2>Aleksandra Skatova</h2>
                        <p class="underTitle" style="font-size: 18px; margin: 0;">{{ $t("companyData.budgeter") }}</p>
                        <div class="iconLine">
                            <img class="dataIcon" :src="require('@/assets/icons/dark/phone.svg')"/>
                            <p style="font-size: 18px;">+372 53668864</p>
                        </div>
                    </div>
                    <div class="singleLine" style="margin-top: 25px;">
                        <img 
                            class="sign"
                            @click="openPage()"
                            :src="require('@/assets/images/partners/bu-logo.jpg')"
                            alt=""
                        >
                    </div>
                </div>
            </div>
                    
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import languageSwitcher from "@/components/languageSwitcher.vue"
import Tr from "@/i18n/translation"

export default {
    name: 'footerMain',
    setup() {
        return { Tr } 
    },
    components: {
        languageSwitcher
    },
    methods: {
        openLink() {
            const url = `https://www.teatmik.ee/en/personlegal/16329376-P%C3%A4rnu-Betoonelement-O%C3%9C`;

            window.open(url, "_blank", "noopener,noreferrer");
        },  
        openPage() {
            const url = `https://betoon.org`;

            window.open(url, "_blank", "noopener,noreferrer");
        },
        openMaps(address) {
            const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

            window.open(url, "_blank", "noopener,noreferrer");
        },  
    }
}
</script>

<style scoped>
.componentWrapper {
    position: relative;
    overflow: hidden;
}
.homeDarkSection {
    position: relative;
    overflow: hidden;
    padding-top: 30px;
    padding-bottom: 30px;
    background: rgb(66, 74, 95);
    clip-path: ellipse(65% 100% at top center);
    z-index: 1;

}
.illustration {
    position: absolute;
    left: -0px;
    top: -0px;
    width: 100%;
    opacity: .25;
}
.homeDarkSection h2 {
    position: relative;
    z-index: 10;
    color: white;
    font-size: 45px;
}
.whiteLogo {
    position: relative;
    z-index: 10;
    width: 240px;
}
.footer {
    position: relative;
    width: 1350px;
    margin: 0 auto;
    margin-top: -20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}
.footerSmall {
    width: 1200px;
}
.top {
    margin-top: -15px;
    width: 100%;
    position: relative;
    text-align: start;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}

.buLogo {
    width: 350px;
    margin-top: 0px;
    padding-bottom: 20px;
    padding-right: 50px;
    border-bottom: 2px solid rgba(158, 174, 187, 0.226);
}
.contact {
    position: relative;
    top: 10px;
    right: 0;
    margin-top: 0px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.contact span {
    font-size: 18px;
}
.sign {
    width: 350px;
}
.data {
    width: 350px;
    margin-top: 30px;
}
.data span {
    font-size: 18px;
    color: steelblue;
}
.data p {
    color: #8f9dbb;
    margin-top: 8px;
    margin-bottom: 10px;
}
.leftSide {
    position: relative;
    width: 43%;
    text-align: left;
    margin-top: -50px;
    z-index: 0;
}
.colorBox {
    background-color: #EFF2F8;
    padding: 55px 20px 20px 40px;
    border-radius: 10px;
}
.rightSide {
    text-align: start;
    width: 57%;
    padding: 10px 0px 0px 40px;
}
.contactTitle {
    font-size: 28px;
    margin: 0;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgb(218, 227, 235);
    color: rgb(55, 114, 163);
}
.flexContainer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}
.inputIcon {
    
    z-index: 20;
    width: 30px;
    opacity: 1;
}
.singleLine {
    margin-top: 10px;
    margin-bottom: 0px;
}
.underTitle {
    color: #8f9dbb;
    margin-bottom: 8px;
    font-size: 18px;
}
.leftSide h2 {
    margin: 0;
    margin-bottom: -5px;
    margin-top: 10px;
    font-size: 22px;
    color: rgb(11, 27, 41);
}
.leftSide p, .leftSide a {
    color: #495264;
    margin-bottom: 5px;
}
.iconLine {
    margin-top: 15px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 10px;
    color: #5f7091;
}
.iconLine a {
    color: #5f7091;
}
.iconLine img {
    margin-right: 10px;
}
.bottom {
    position: relative;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    padding-top: 15px;
    padding-bottom: 15px;
}
.links a {
    margin-right: 20px;
    font-weight: bold;
    color: rgb(50,50,50);
    cursor: pointer;
    text-decoration: none;
}
.bottom p {
    text-align: start;
    margin-top: 15px;
    font-size: 16px;
    width: 100%;
}
.langSwitcher {
    margin-top: 35px;
    border: 1px solid rgba(70, 131, 180, 0.425);
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 10px;
    background: #EFF3F7;
}
.iconLine p {
    margin-top: 0;
}
@media (max-width: 1350px) {
    .footer {
        width: 100%;
    }
    .top {
        width: 100%;
        margin: 0 auto;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
    .bottom {
        width: 100%;
        margin: 0 auto;
    }
}
@media (max-width: 1235px) {
    .sign {
        bottom: 50px;
        right: 25px;
    }
}
@media (max-width: 1050px) {
    .homeDarkSection {
        clip-path: ellipse(90% 100% at top center);
    }
}
@media (max-width: 850px) {
    .contact {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
    .leftSide {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        -webkit-box-ordinal-group: 3;
            -ms-flex-order: 2;
                order: 2;
        margin-top: 20px;
    }
    .rightSide { 
        width: 100%;
        padding-left: 0px;
        -webkit-box-ordinal-group: 2;
            -ms-flex-order: 1;
                order: 1;
    }
    .colorBox {
        padding-top: 20px;
    }
}
@media (max-width: 750px) {
    .homeDarkSection {
        padding-top: 20px;
        padding-bottom: 60px;
        clip-path: ellipse(120% 100% at top center);
    }
    .illustration {
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
           object-fit: cover;
    }
    .homeDarkSection h2 {
        font-size: 36px;
    }
    .whiteLogo {
        width: 200px;
    }
}
@media (max-width: 650px) {
    .contact {
        width: 100%;
    }
}
@media (max-width: 670px) {
    
    
}
@media (max-width: 500px) {
    .homeDarkSection h2 {
        font-size: 32px;
    }
    .whiteLogo {
        width: 180px;
    }
    .contact {
        padding-left: 20px;
        padding-right: 20px;
    }
    .colorBox {
        padding-left: 20px;
    }
}
@media (max-width: 450px) {
    
    .data  {
        width: 100%;
        text-align: start;
    }
    .data span {
        font-size: 16px;
    }
}
@media (max-width: 390px) {
    .homeDarkSection h2 {
        font-size: 30px;
        margin-top: 5px;
    }
    .sign {
        width: 100%;
    }
    .whiteLogo {
        width: 180px;
    }
}
</style>
